import React from 'react';

export default () => (
    <svg width="24" height="24" viewBox="0 0 24 24">
        <rect width="24" height="24" fill="none" />
        <rect width="24" height="20" rx="2" transform="translate(0 2)" fill="#4d6ffb" />
        <rect width="18" height="10" rx="2" transform="translate(3 5.5)" fill="#eaecf5" />
        <rect width="16" height="2" rx="1" transform="translate(4 17)" fill="#8ba1fd" />
    </svg>
);